import _MpPicker from "./MpPicker.vue"
import withInstall from "../../utils/withInstall"
export const MpPicker = withInstall(_MpPicker)
export default MpPicker
